import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../BasePanelPage";
import {donateMobileState} from "../../../../inline-donation/DonateMobileState";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";
import {Messages} from "../../../../../Messages";
import {Link} from "../../../../../../stem-core/src/ui/UIPrimitives";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {redirectToMerchantHomepage} from "../../../../../widget/misc/WidgetUtils";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {DonationFailedPanelStyle} from "../DonationFailedPanel";
import {PaymentFailedIcon} from "../../../../../SVGElements";
import {Perk} from "../../subscribe/components/CoverageDescriptionElements";
import {iFrameState} from "../../../../../services/IFrameState";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {TNR_ALIAS} from "../../../../../../blink-sdk/Constants";
import {startDonationFlow} from "../../../../flows/startFlow";


@registerStyle(DonationFailedPanelStyle)
export class DonationCanceledPanel extends BasePanelPage {
    getGuidelines() {
        if (iFrameState.forceHideWallet) {
            return [];
        }

        const {styleSheet} = this;

        return [
            <div className={styleSheet.message}>{Messages.donationCanceledText2}</div>,
            <Perk text={Messages.donationCanceledGuideline1}/>,
            <Perk text={Messages.donationCanceledGuideline2}/>,
        ];
    }

    render() {
        const {styleSheet} = this;
        const donation = donateMobileState.previouslyCanceledDonation;
        const publicationName = iFrameMerchantService.getMerchant().name;

        return [
            iFrameMerchantService.isMerchant(TNR_ALIAS) ? null : <PaymentFailedIcon className={styleSheet.icon} color={this.styleSheet.themeProps.MERCHANT_TEXT_SECONDARY_COLOR}/>,
            <div className={styleSheet.title}>{Messages.donatePageDonationCanceledTitle}</div>,
            <MessageElement className={styleSheet.message}
                            message={Messages.donationCanceledText1(donation.formatPrice())}/>,
            this.getGuidelines(),
            <MerchantButton onClick={redirectToMerchantHomepage} className={styleSheet.button}>
                {Messages.returnToHomepage(publicationName)}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.donatePageDonationCanceledMakeDonation} className={styleSheet.secondaryButton}
                      onClick={() => startDonationFlow()} />
            </div>,
        ];
    }
}
